import type { CampaignFilters, TaskStatus } from '../types/campaign.types';

export const campaignKeys = {
  all: ['campaigns'] as const,
  lists: () => [...campaignKeys.all, 'list'] as const,
  list: (orgId?: string, filters?: CampaignFilters) =>
    [
      ...campaignKeys.all,
      'list',
      orgId || 'no-org',
      filters?.searchTerm || '',
      filters?.brand || 'all',
      filters?.owner || 'all',
      filters?.dateRange || 'all',
      filters?.page || 1,
      filters?.pageSize || 10,
    ] as const,
  options: (orgId?: string) => [...campaignKeys.all, 'options', orgId || 'no-org'] as const,
  details: () => [...campaignKeys.all, 'detail'] as const,
  detail: (id?: string) => [...campaignKeys.all, 'detail', id || 'no-id'] as const,
  withContact: (id?: string) => ['campaign-with-contact', id || 'no-id'] as const,
  influencers: (id?: string) => ['campaign-influencers', id || 'no-id'] as const,
  tasks: (id?: string, filters?: { status?: TaskStatus; assignedTo?: string }) =>
    ['campaign-tasks', id || 'no-id', filters] as const,
  notes: (id?: string) => ['campaign-notes', id || 'no-id'] as const,
  expenses: (id?: string, orgId?: string) => ['campaign-expenses', id || 'no-id', orgId || 'no-org'] as const,
  budget: (id?: string) => ['campaign-budget-calculations', id || 'no-id'] as const,
  timeSeries: (id?: string) => ['campaign-performance-timeseries', id || 'no-id'] as const,
  ranking: (orgId?: string) => ['campaign-performance-ranking', orgId || 'no-org'] as const,
};
